import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function MitarbeiterErstellt() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4 items-center">
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="size-12 text-primary-green-500"
      />
      <span className="text-neutrals-900 text-xl font-bold leading-7">
        {t('domain.mitarbeiter.create.success.message')}
      </span>
      <span className="text-neutrals-900 text-sm font-normal leading-5">
        {t('domain.mitarbeiter.create.success.description')}
      </span>
    </div>
  );
}
